import { render, staticRenderFns } from "./TermsAndConditionsDetailsNavbar.vue?vue&type=template&id=33164a2c&scoped=true&"
import script from "./TermsAndConditionsDetailsNavbar.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsDetailsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsDetailsNavbar.vue?vue&type=style&index=0&id=33164a2c&lang=scss&scoped=true&"
import style1 from "./TermsAndConditionsDetailsNavbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33164a2c",
  null
  
)

export default component.exports